<template>
  <ArticleHeaderButton
    v-if="fileSource && !isBlocked"
    class="article-header-download-button"
    :outlined="videoMimeType"
    button-text="Download"
    :aria-label="downloadBtnAriaLabel"
    emit-on-click="download"
    data-test-id="DownloadButton"
    @download="onDownload"
  >
    <DownloadIcon
      :class="
        !newArticleDetailsDisplay && 'article-header-download-button__icon'
      "
    />
  </ArticleHeaderButton>
</template>

<script>
import mapFlags from "~/plugins/utilities/mapFlags";
import ArticleHeaderButton from "~/components/articles/ArticleHeaderButton.vue";
import DownloadIcon from "~/components/articles/components/icons/DownloadIcon.vue";

export default {
  name: "ArticleHeaderDownloadButton",
  components: { ArticleHeaderButton, DownloadIcon },
  props: {
    article: { type: Object, required: true },
    videoMimeType: { type: Boolean, default: false },
  },
  computed: {
    ...mapFlags(["newArticleDetailsDisplay"]),
    isBlocked() {
      return this.article.blocked;
    },
    fileSource() {
      const { asset } = this.article || {};

      if (!asset) {
        return;
      }

      return asset.original ? asset.original.url : undefined;
    },
    fileType() {
      const { asset } = this.article || {};

      if (asset?.fileName) {
        const bits = asset.fileName.split(".");
        const lastBit = bits.length - 1;

        if (lastBit >= 0) {
          return bits[lastBit];
        }
      }

      return "";
    },
    fileSize() {
      const { asset } = this.article || {};

      if (asset?.fileSizeMegabytes) {
        if (asset.fileSizeMegabytes > 1) {
          return Math.floor(asset.fileSizeMegabytes).toString();
        }

        return asset.fileSizeMegabytes.toFixed(2);
      }

      return "";
    },
    downloadBtnAriaLabel() {
      return `Download ${this.article.title} ${this.fileType} ${
        this.fileSize ? `,${this.fileSize} megabytes` : ""
      }. Opens in a new tab`;
    },
  },
  methods: {
    onDownload() {
      const url = this.fileSource;

      if (url) {
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.article-header-download-button {
  &__icon {
    padding-top: 2px;
    padding-bottom: 2px;
  }
}
</style>
